import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { LoanPaymentCreateInput, LoanPaymentUpdateInput } from '@libs/types/src/mado/input-type';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { LoanPaymentGridObject, LoanPaymentObject } from '@libs/types/src/mado/object-type/loan-payment.object';

@Injectable({ providedIn: 'root' })
export class LoanPaymentGqlService extends GqlServiceV2 {

    public getLoanPayments(input: GridInput | null, frag: string) {
        return this.query<LoanPaymentGridObject>(
            `
                query($input: GridInput!) {
                    loanPayment {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createLoanPayment(input: LoanPaymentCreateInput, frag: string) {
        return this.mutate<LoanPaymentObject>(
            `
                mutation($input: LoanPaymentCreateInput!) {
                    loanPayment {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateLoanPayment(input: LoanPaymentUpdateInput, frag: string) {
        return this.mutate<LoanPaymentObject>(
            `
                mutation($input: LoanPaymentUpdateInput!) {
                    loanPayment {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteLoanPayment(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanPayment {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public synchronizeLoanPayments(frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation {
                    loanPayment {
                        synchronize {
                            ${frag}
                        }
                    }
                }
            `,
        );
    }
}
